<template>
  <CheckFormBox :title="$t('message.DataRegistration.formData.owner_data')">
    <el-row :gutter="48">
      <el-col :xs="24" :sm="24">
        <el-row :gutter="48">
          <!-- SP查詢編號 -->
          <el-col :xs="24" :sm="12">
            <div class="form_label">{{$t('message.spNo')}}：</div>
            <div class="form_value">{{verifyForm.spNo}}</div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="48">
      <!-- 配額人的證件類別 -->
      <el-col
        :xs="24"
        :sm="12"
        v-if="serviceType == 'HZMB_FIRST_PERSON' || serviceType == 'HZMB_RENEW_PERSON'"
      >
        <div class="form_label">{{$t('message.DataRegistration.Quota.idType')}}：</div>
        <div
          class="form_value"
        >{{data.personIdentityType && idType.length > 0 ? idType.find(item => item.codeKey == data.personIdentityType)[$t('message.codeName')] : ''}}</div>
      </el-col>
      <!-- 配額人的澳門居民身份證編號 -->
      <el-col
        :xs="24"
        :sm="12"
        v-if="serviceType == 'HZMB_FIRST_PERSON' || serviceType == 'HZMB_RENEW_PERSON'"
      >
        <div class="form_label">{{$t('message.DataRegistration.Quota.personIdentityNo')}}：</div>
        <div class="form_value">{{data.personIdentityNo}}</div>
      </el-col>
    </el-row>

    <!-- PERSON -->
    <div v-if="serviceType == 'HZMB_FIRST_PERSON' || serviceType == 'HZMB_RENEW_PERSON'">
      <el-row :gutter="48">
        <!-- 配額人的中文姓名 -->
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.personNameCn')}}：</div>
          <div class="form_value">{{data.personNameCn}}</div>
        </el-col>
        <!-- 配額人的外文姓名 -->
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.personNameEn')}}：</div>
          <div class="form_value">{{data.personNameEn}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="48">
        <!-- 配額人的出生日期 -->
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.personBirthday')}}：</div>
          <div class="form_value">{{data.personBirthday | formatDT('dd/MM/yyyy')}}</div>
        </el-col>
      </el-row>
    </div>

    <!-- COMPANY -->
    <div v-if="serviceType == 'HZMB_FIRST_COMPANY' || serviceType == 'HZMB_RENEW_COMPANY'">
      <el-row :gutter="48">
        <!-- 商業登記類型 -->
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.companyIdentityType')}}：</div>
          <div
            class="form_value"
          >{{data.companyIdentityType && companyType.length > 0 ? $t(companyType.find(item => item.code == data.companyIdentityType).label) : ''}}</div>
        </el-col>
        <!-- 商業登記編號 -->
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.companyBrNo')}}：</div>
          <div class="form_value">{{data.companyBrNo}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="48">
        <!-- 商業登記名稱（中文） -->
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.companyNameCn')}}：</div>
          <div class="form_value">{{data.companyNameCn}}</div>
        </el-col>
        <!-- 商業登記名稱（外文） -->
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{$t('message.DataRegistration.Quota.companyNameEn')}}：</div>
          <div class="form_value">{{data.companyNameEn}}</div>
        </el-col>
      </el-row>
    </div>

    <!-- PUBLIC -->
    <el-row :gutter="48">
      <!-- 配額人的本澳流動電話 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Quota.macauMobile')}}：</div>
        <div class="form_value">{{data.macauMobile ?'+853':''}} {{data.macauMobile}}</div>
      </el-col>
    </el-row>
    <!-- macauAddress -->
    <!-- 配額人的澳門聯絡地址 -->
    <el-row :gutter="48">
      <el-col v-if="applicationType == 'FIRST'" :span="24">
        <div
          class="form_label"
        >{{ $t('message.macauAddress.quotaMacauAddress')}}：</div>
        <div class="form_value">{{data.macauAddress.textCn || data.macauAddress.textPt}}</div>
      </el-col>
    </el-row>
    <!-- OTHER -->
    <el-row :gutter="48">
      <!-- 配額人的內地聯絡電話 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Quota.mainlandPhone')}}：</div>
        <div class="form_value">{{data.mainlandPhone ?'+86':''}} {{data.mainlandPhone}}</div>
      </el-col>
      <!-- 配額人的內地電郵地址 -->
      <el-col :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Quota.mainlandEmail')}}：</div>
        <div class="form_value">{{data.mainlandEmail}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="48">
      <!-- 配額人的香港聯絡電話 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Quota.hkPhone')}}：</div>
        <div class="form_value">{{data.hkPhone ?'+852':''}} {{data.hkPhone}}</div>
      </el-col>
      <!-- 配額人的其他聯絡電話 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="12">
        <div class="form_label">{{$t('message.DataRegistration.Quota.otherPhone')}}：</div>
        <div class="form_value">{{data.otherPhone}}</div>
      </el-col>
    </el-row>
    <el-row :gutter="48">
      <!-- 配額人的香港聯絡地址 -->
      <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="24">
        <div class="form_label">{{$t('message.DataRegistration.Quota.hkAddress')}}：</div>
        <div class="form_value">{{data.hkAddress}}</div>
      </el-col>
    </el-row>
  </CheckFormBox>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import CheckFormBox from "./CheckFormBox";
import VssViewAPI from "../../../../api/VssViewAPI";
export default {
  props: ["data"],
  components: { CheckFormBox },
  data() {
    return {
      idType: [],
      companyType: [
        {
          code: "CO",
          label: "message.companyTypeCO",
        },
        {
          code: "EM",
          label: "message.companyTypeEM",
        },
        {
          code: "SO",
          label: "message.companyTypeSO",
        },
      ],
    };
  },
  computed: {
    serviceType() {
      return this.$store.state.serviceType;
    },
    quotaType() {
      return this.serviceType == "HZMB_FIRST_PERSON" ||
        this.serviceType == "HZMB_RENEW_PERSON"
        ? this.$t("message.DataRegistration.Quota.personal")
        : this.$t("message.DataRegistration.Quota.company");
    },
    verifyForm() {
      return this.$store.state.verifyForm;
    },
    applicationType() {
      const serviceType = this.$store.state.serviceType;
      return serviceType == "HZMB_FIRST_PERSON" ||
        serviceType == "HZMB_FIRST_COMPANY"
        ? "FIRST"
        : "RENEW";
    },
  },
  created() {
    if (
      this.serviceType == "HZMB_FIRST_PERSON" ||
      this.serviceType == "HZMB_RENEW_PERSON"
    ) {
      VssViewAPI.getIdentityTypes()
        .then((res) => {
          this.idType = res;
        })
        .catch((err) => {
          this.$error(err);
        });
    }
  },
};
</script>
